import { config } from '@uhg-abyss/web/tools/config';

config('APP_ENV');
